export const noSpecialCharacters = new RegExp(/^[^$%=@¢£]+$/i); // Using a simple blacklist instead of whitelist since we want to allow all letters with umlauts and accent marks (ü, ú, ì, etc)
export const phonenumberRegex = new RegExp(/^[\d-\s+]+$/i); // Only allow digits, dashes (-), spaces and plus signs (+)
export const emailRegex = new RegExp(
	/^(([^\s"(),.:;<>@[\\\]]+(\.[^\s"(),.:;<>@[\\\]]+)*)|(".+"))@((\[(?:\d{1,3}\.){3}\d{1,3}])|(([\dA-Za-z-]+\.)+[A-Za-z]{2,}))$/,
);
